import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import { managementService } from '../../services/api';

const HeroSlider = () => {
    const heroSwiperRef = useRef(null);
    const [slides, setSlides] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSlides();
    }, []);

    const fetchSlides = async () => {
        try {
            const data = await managementService.getSlides();
            // priority'ye göre sırala
            const sorted = (data || []).sort((a, b) => (a.priority || 0) - (b.priority || 0));
            setSlides(sorted);
        } catch (err) {
            console.error('Slides API error:', err);
        } finally {
            setLoading(false);
        }
    };

    // Loading state
    if (loading) {
        return (
            <div className="max-w-6xl mx-auto px-3 sm:px-4 md:px-6 relative mt-8 sm:mt-10 md:mt-24">
                <div className="h-[140px] sm:h-[200px] md:h-[311px] rounded-2xl sm:rounded-3xl bg-gray-100 animate-pulse" />
            </div>
        );
    }

    // Boş durum
    if (slides.length === 0) {
        return null;
    }

    return (
        <div className="max-w-6xl mx-auto px-3 sm:px-4 md:px-6 relative mt-8 sm:mt-10 md:mt-24">
            <div className="relative px-8 sm:px-10 md:px-0">
                <Swiper
                    onSwiper={(swiper) => (heroSwiperRef.current = swiper)}
                    modules={[Navigation, Autoplay]}
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    className="heroSwiper rounded-2xl sm:rounded-3xl"
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index} className='rounded-2xl sm:rounded-3xl'>
                            <a target='_blank' href={slide.url}>
                                <motion.div className="relative h-[140px] sm:h-[200px] md:h-[311px] rounded-2xl sm:rounded-3xl">
                                    {/* Desktop image */}
                                    <img
                                        src={slide.desktop?.image || slide.url}
                                        alt={slide.title || ''}
                                        className="hidden md:block w-full h-full object-cover shadow-2xl rounded-2xl sm:rounded-3xl"
                                    />
                                    {/* Mobile image */}
                                    <img
                                        src={slide.mobile?.image || slide.desktop?.image || slide.url}
                                        alt={slide.title || ''}
                                        className="block md:hidden w-full h-full object-cover shadow-2xl rounded-2xl sm:rounded-3xl"
                                    />
                                </motion.div>
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Slider Navigasyon Butonları */}
                {slides.length > 1 && (
                    <>
                        <motion.button
                            onClick={() => heroSwiperRef.current?.slidePrev()}
                            className="absolute left-1 sm:left-2 top-1/2 -translate-y-1/2 w-7 h-7 sm:w-8 sm:h-8 md:w-12 md:h-12 md:-translate-x-12 rounded-full flex items-center justify-center transition-all z-10 cursor-pointer group"
                            aria-label="Previous slide"
                        >
                            <img src="/left.svg" alt="Previous" className="w-full h-full transition-transform group-hover:scale-110" />
                        </motion.button>

                        <motion.button
                            onClick={() => heroSwiperRef.current?.slideNext()}
                            className="absolute right-1 sm:right-2 top-1/2 -translate-y-1/2 w-7 h-7 sm:w-8 sm:h-8 md:w-12 md:h-12 md:translate-x-16 rounded-full flex items-center justify-center transition-all z-10 cursor-pointer group"
                            aria-label="Next slide"
                        >
                            <img src="/right.svg" alt="Next" className="w-full h-full transition-transform group-hover:scale-110" />
                        </motion.button>
                    </>
                )}
            </div>
        </div>
    );
};

export default HeroSlider;